import React from 'react';

function TemplatesModal({
  showModal,
  onClose,
  medicalTemplates,
  prescriptionTemplates,
  newType,
  setNewType,
  newLabel,
  setNewLabel,
  newText,
  setNewText,
  editLabel,
  setEditLabel,
  editText,
  setEditText,
  editing,
  addTemplate,
  startEdit,
  saveEdit,
  deleteTemplate
}) {
  if (!showModal) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '740px', width: '100%' }}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2 style={{ color: '#4a90e2', fontSize: '1.5rem', marginBottom: '1rem', borderBottom: '2px solid rgba(74, 144, 226, 0.3)', paddingBottom: '0.5rem' }}>Gerenciar Modelos</h2>

        <div className="form-row" style={{ marginBottom: 8 }}>
          <div className="form-group" style={{ maxWidth: 180 }}>
            <label>Tipo</label>
            <select value={newType} onChange={(e) => setNewType(e.target.value)}>
              <option value="medical">Prontuário</option>
              <option value="prescription">Receita</option>
            </select>
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Título do modelo</label>
            <input
              type="text"
              placeholder="Título do modelo"
              value={newLabel}
              onChange={(e) => setNewLabel(e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Conteúdo do modelo</label>
          <textarea
            value={newText}
            onChange={(e) => setNewText(e.target.value)}
            placeholder="Conteúdo do modelo"
          />
        </div>
        <div className="button-container" style={{ marginTop: 8 }}>
          <button
            className="button button-primary"
            onClick={addTemplate}
            disabled={!newLabel || !newText}
          >
            Adicionar modelo
          </button>
        </div>

        <h4 style={{ marginTop: 18, color: '#4a90e2' }}>Modelos de Prontuário</h4>
        <div className="bookings-list">
          {medicalTemplates.map((t, idx) => (
            <div key={t.value || idx} className={`booking-item ${editing && editing.type === 'medical' && editing.index === idx ? 'active' : ''}`}>
              {editing && editing.type === 'medical' && editing.index === idx ? (
                <div>
                  <div className="form-group" style={{ marginBottom: 8 }}>
                    <label>Título</label>
                    <input
                      type="text"
                      value={editLabel}
                      onChange={(e) => setEditLabel(e.target.value)}
                      placeholder="Título"
                    />
                  </div>
                  <div className="form-group">
                    <label>Conteúdo</label>
                    <textarea
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      placeholder="Conteúdo"
                    />
                  </div>
                  <div className="button-container" style={{ marginTop: 8 }}>
                    <button className="button button-primary" onClick={saveEdit}>Salvar</button>
                    <button className="button button-secondary" onClick={onClose}>Fechar</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: 500, color: '#e0e0e0' }}>{t.label}</div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="button button-secondary" onClick={() => startEdit('medical', idx)}>Editar</button>
                    <button className="button button-danger" onClick={() => deleteTemplate('medical', idx)}>Excluir</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <h4 style={{ marginTop: 18, color: '#4a90e2' }}>Modelos de Receita</h4>
        <div className="bookings-list">
          {prescriptionTemplates.map((t, idx) => (
            <div key={t.value || idx} className={`booking-item ${editing && editing.type === 'prescription' && editing.index === idx ? 'active' : ''}`}>
              {editing && editing.type === 'prescription' && editing.index === idx ? (
                <div>
                  <div className="form-group" style={{ marginBottom: 8 }}>
                    <label>Título</label>
                    <input
                      type="text"
                      value={editLabel}
                      onChange={(e) => setEditLabel(e.target.value)}
                      placeholder="Título"
                    />
                  </div>
                  <div className="form-group">
                    <label>Conteúdo</label>
                    <textarea
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      placeholder="Conteúdo"
                    />
                  </div>
                  <div className="button-container" style={{ marginTop: 8 }}>
                    <button className="button button-primary" onClick={saveEdit}>Salvar</button>
                    <button className="button button-secondary" onClick={onClose}>Fechar</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: 500, color: '#e0e0e0' }}>{t.label}</div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="button button-secondary" onClick={() => startEdit('prescription', idx)}>Editar</button>
                    <button className="button button-danger" onClick={() => deleteTemplate('prescription', idx)}>Excluir</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TemplatesModal;


